<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true"
  [config]="{ignoreBackdropClick: true, keyboard: false}" (onShown)="onShown()">
  <div class="modal-dialog modal-lg">
    <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Medicamento</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors">{{error}}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-9">
              <mat-form-field>
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="descricao" type="text" #focus />
                <mat-error>Informe um Descrição válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Concentração</mat-label>
                <input matInput formControlName="concentracao" type="text" />
                <mat-error>Informe um Concentração válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Qtd. Embalagem</mat-label>
                <input matInput formControlName="qtdEmbalagem" type="text" />
                <mat-error>Informe uma Qtd. Embalagem válida.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Via</mat-label>
                <mat-select formControlName="via" required>
                  <mat-option *ngFor="let via of typesService.viaType" [value]="via.value">
                    {{via.text}}</mat-option>
                </mat-select>
                <mat-error>Selecione uma Via válida.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Vlr. Unitário</mat-label>
                <input matInput formControlName="vlrUnitario" type="text" currencyMask />
                <mat-error>Informe um Vlr Unitário válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Forma de Uso</mat-label>
                <textarea matInput formControlName="formaUso" rows="3"></textarea>
                <mat-error>Informe uma Forma de Uso válida.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Apresentação</mat-label>
                <textarea matInput formControlName="apresentacao" rows="2"></textarea>
                <mat-error>Informe um Apresentação válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Princípio Ativo</mat-label>
                <textarea matInput formControlName="principioAtivo" rows="2"></textarea>
                <mat-error>Informe um Princípio Ativo válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <section>
                <mat-checkbox formControlName="usoFrequente" style="margin: 2px 8px auto 0 !important;" color="primary">
                  Uso Frequente</mat-checkbox>
              </section>
            </div>
          </div>
        </div>
      </form>
      <div class="footer">
        <mat-slide-toggle [(ngModel)]="multiCreate" color="primary" *ngIf="newItem" style="margin-right: 10px;">
          Continuar Incluindo
        </mat-slide-toggle>
        <button mat-flat-button [disabled]="!form.valid || isBusy" type="submit" (click)="save()" color="primary"
          class="button-row">
          <span> Salvar</span>
        </button>
        <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
          <span> Cancelar</span>
        </button>
      </div>
    </div>
  </div>
</div>